<template>
  <div>
    <NBar title="设备操作" :top="true"/>
    <div class='item-div'>
      <div class='item'>
        <nut-textinput :show-icon="true" label="设备名称：" placeholder="请填写设备名称" v-model="saveForm.name" :clearBtn="false"
                       :has-border="false" style="width: 100%;"/>
      </div>
      <div class='item'>
        <nut-textinput :show-icon="true" label="设备ID：" placeholder="请填写设备ID" v-model="saveForm.deviceId"
                       :clearBtn="false" :has-border="false" style="width: 100%;"/>
      </div>
      <div class='item'>
        <nut-textinput :show-icon="true" label="设备鉴权key：" placeholder="请填写设备鉴权key" v-model="saveForm.apikey"
                       :clearBtn="false" :has-border="false" style="width: 100%;"/>
      </div>
      <nut-cell :show-icon="true" style="margin-bottom: 10px;" @click.native="openMerchant()">
        <span slot="title">选择商家</span>
        <span slot="desc">{{saveForm.merName != null && saveForm.merName != '' ? saveForm.merName : '未设置'}}</span>
      </nut-cell>
      <!--选择商家弹窗-->
      <nut-popup v-model="showMerchant" position="bottom" closeable :style="{height: '70%'}">
        <div class="popup-top-div">
          <nut-cell style="margin-top: -3px;">
            <span slot="title" style="font-size: 16px;">选择商家</span>
          </nut-cell>
          <nut-searchbar ref="merchantSearch" @submit="merchantSearch" v-model="merchantSearchName" place-text="请输入商家名称"
                         style="margin: 10px;"/>
        </div>
        <m-list style="height:calc(100vh - 300px);margin-top: 100px" ref="merchantList" :data.sync="merchantList"
                :page.sync="merchantPage" :limit.sync="merchantLimit" @loadlist="getMerchantList">
          <div slot="list">
            <nut-cell v-for="(item ,index) in merchantList" :key="index">
              <span slot="title">{{item.name}}</span>
              <span slot="desc">
                <nut-radio v-model="selectMerchantIndex" :label="index"/>
              </span>
            </nut-cell>
          </div>
        </m-list>
        <div class="bottom">
          <nut-button class="btn" small @click.native="merchantConfirm">确定</nut-button>
        </div>
      </nut-popup>
      <template v-if="accountAdd">
        <div class="title">设置商家帐号密码:</div>
        <div class='item'>
          <nut-textinput :show-icon="true" label="姓名：" placeholder="请输入真实姓名" v-model="saveForm.truename"
                         :clearBtn="false" :has-border="false" style="width: 100%;"/>
        </div>
        <div class='item'>
          <nut-textinput :show-icon="true" label="帐号：" placeholder="请输入账号" v-model="saveForm.username"
                         :clearBtn="false" :has-border="false" style="width: 100%;"/>
        </div>
        <div class='item'>
          <nut-textinput :show-icon="true" label="密码：" placeholder="请输入密码" v-model="saveForm.password"
                         :clearBtn="false" :has-border="false" style="width: 100%;" type="password"/>
        </div>
      </template>
      <!--选择地址弹窗 end-->
      <nut-cell :show-icon="true" style="margin-bottom: 10px;" @click.native="showSite = true">
        <span slot="title">选择地址</span>
        <span slot="desc">{{address == null && address == '' ? '未设置' : address.length < 22 ? address : address.substring(0,22) + '...'}}</span>
      </nut-cell>
      <!--选择场地弹窗-->
      <nut-popup v-model="showSite" position="bottom" closeable>
        <div class="popup-top-div">
          <nut-cell style="margin-top: -3px;">
            <span slot="title" style="font-size: 16px;">选择场地</span>
          </nut-cell>
          <nut-searchbar ref="siteSearch" @submit="siteSearch" v-model="siteSearchName" place-text="请输入场地名称"
                         style="margin: 10px;"/>
        </div>
        <m-list style="height:calc(100vh - 390px);margin-top: 100px" ref="addressList" :data.sync="addressList"
                :page.sync="page" :limit.sync="limit" @loadlist="getAddressList">
          <div slot="list">
            <nut-cell v-for="(item ,index) in addressList" :key="index">
              <span slot="title">{{item.name}}</span>
              <span slot="desc" style="font-size: 14px;">{{item.deviceCount + '台'}}
                <nut-radio v-model="selectIndex" :label="index"/>
              </span>
            </nut-cell>
          </div>
        </m-list>
        <div class="bottom">
          <nut-button class="btn" small @click.native="confirm">确定</nut-button>
        </div>
      </nut-popup>
      <!--选择场地弹窗 end-->
      <div class='item'>
        <nut-radiogroup v-model="saveForm.type">
          <nut-radio v-if="!edit" :label="1">注册</nut-radio>
          <nut-radio :label="2">转移</nut-radio>
          <nut-radio :label="3">解绑</nut-radio>
        </nut-radiogroup>
      </div>
    </div>
    <nut-button style="margin: 30px 15px;border-radius: 5px;width:92%;" @click.native="save()">保存</nut-button>
  </div>
</template>

<script>
export default {
  name: 'DeviceSet',
  props: ['data'],
  data () {
    return {
      saveForm: {
        id: null,
        merId: null,
        merName: '',
        name: '',
        deviceId: '',
        apikey: '',
        addressId: null,
        type: 1,
        truename: '',
        username: '',
        password: ''
      },
      page: 1,
      limit: 10,
      merchantPage: 1,
      merchantLimit: 6,
      selectMerchantIndex: 0,
      //是否显示选择商家
      showMerchant: false,
      merchantList: [],
      merchantSearchName: '',
      merchantName: '',
      selectIndex: 0,
      addressList: [],
      //是否显示选择场地
      showSite: false,
      siteSearchName: '',
      addrMerId: 0,
      address: '',
      edit: false,
      accountAdd: true,
    }
  },
  mounted () {
    if (!this.$util.isArrOrNull(this.data)) {
      let data = JSON.parse(decodeURIComponent(this.data))
      this.$util.ofData(this.saveForm, data)
      this.edit = true
      this.saveForm.type = 2
      this.merchantName = data.merchantName
      this.address = data.addressName
      this.getAccount()
    }
    this.getAddressList()
  },
  methods: {
    siteSearch (value) {
      this.page = 1
      this.siteSearchName = value
      //点击键盘中的’搜索‘时，失去焦点
      this.$refs.siteSearch.blur()
      this.getAddressList()
    },
    //查询场地列表
    getAddressList () {
      let data = {
        page: this.page,
        limit: this.limit
      }
      if (this.addrMerId != 0) {
        data.merId = this.addrMerId
      }
      if (this.siteSearchName != '') {
        data.searchName = this.siteSearchName
      }
      this.$api.post({
        url: '/device/api/device/address/list',
        data: data
      }).then(res => {
        this.$refs.addressList.setRes(res)
      })
    },
    confirm () {
      this.address = this.addressList[this.selectIndex].name
      this.saveForm.addressId = this.addressList[this.selectIndex].id
      this.showSite = false
    },
    merchantSearch (value) {
      this.merchantPage = 1
      this.merchantSearchName = value
      //点击键盘中的’搜索‘时，失去焦点
      this.$refs.merchantSearch.blur()
      this.getMerchantList()
    },
    openMerchant () {
      this.showMerchant = true
      this.getMerchantList()
    },
    getMerchantList () {
      let data = {
        agentId: this.$api.agentId,
        status: 1,
        page: this.merchantPage,
        limit: this.merchantLimit
      }
      if (this.merchantSearchName != '') {
        data.name = this.merchantSearchName
      }
      this.$api.post({
        url: '/merchant/merchant/find/list',
        data: data
      }).then(res => {
        this.$refs.merchantList.setRes(res)
      })
    },
    merchantConfirm () {
      let merchant = this.merchantList[this.selectMerchantIndex]
      this.saveForm.merName = merchant.name
      this.saveForm.merId = merchant.id
      this.addrMerId = merchant.id
      this.address = ''
      this.saveForm.addressId = null
      this.getAddressList()
      this.getAccount(merchant)
      this.showMerchant = false
    },
    getAccount (merchant) {
      this.$api.post({
        url: '/device/api/device/device-account/find',
        data: {
          merId: this.saveForm.merId
        },
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          this.accountAdd = false
        } else {
          this.accountAdd = true
        }
        if (this.accountAdd && !this.$util.isArrOrNull(merchant)) {
          this.saveForm.truename = merchant.contactName
          this.saveForm.username = merchant.phone
        }
      })
    },
    save () {
      if (this.$util.isArrOrNull(this.saveForm.name)) {
        this.$toast.warn('请输入设备名称!')
        return
      }
      if (this.$util.isArrOrNull(this.saveForm.deviceId)) {
        this.$toast.warn('请输入设备ID!')
        return
      }
      if (this.$util.isArrOrNull(this.saveForm.apikey)) {
        this.$toast.warn('请输入设备apiKey!')
        return
      }
      if (this.$util.isArrOrNull(this.saveForm.merId)) {
        this.$toast.warn('请先选择商家!')
        return
      } else {
        if (this.accountAdd) {
          if (this.$util.isArrOrNull(this.saveForm.truename) || this.$util.isArrOrNull(this.saveForm.username)
            || this.$util.isArrOrNull(this.saveForm.password)) {
            this.$toast.warn('请设置商家名称,登录帐号,密码!')
            return
          }
        }
      }
      if (this.$util.isArrOrNull(this.saveForm.addressId)) {
        this.$toast.warn('请先选择地址!')
        return
      }
      this.$api.post({
        url: '/device/api/device/save',
        data: this.saveForm,
      }).then(() => {
        if (this.accountAdd) {
          this.saveAccount()
        }
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500)
      })
    },
    saveAccount () {
      this.$api.post({
        url: '/device/api/device/device-account/save',
        data: {
          merId: this.saveForm.merId,
          name: this.saveForm.truename,
          username: this.saveForm.username,
          password: this.saveForm.password
        },
      }).then(() => {
      })
    }
  }
}
</script>

<style scoped>

  .title {
    height: 35px;
    line-height: 35px;
    margin-top: 5px;
    color: #848484;
    margin-left: 20px;
  }

  .item-div {
    background: #fff;
  }

  .item-div .item {
    margin-left: 12px;
    padding-right: 12px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f9f9fb;
  }

  .popup-top-div {
    position: fixed;
    background: rgb(255, 255, 255);
    height: 100px;
    width: 100%;
    z-index: 1;
  }

  .bottom {
    width: 100%;
    position: fixed;
    bottom: 0;
    height: 45px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bottom .btn {
    flex: 1;
    border-radius: 0;
    height: 45px;
  }

  >>> .nut-radio input:checked {
    background-color: #007aff;
    border-color: #007aff;
  }

  >>> .nut-radio input:after {
    background: #007aff;
  }

  >>> .nut-button {
    background: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/DeviceSet.vue